/**
 * Плагин: по событию графа node:added-to-view шлёт patch addNode.
 * Событие эмитится при добавлении узла на диаграмму (stencil drop или «добавить элемент на view»).
 */
import {applyViewpointDimming} from '../viewpoint/applyViewpointDimming';

export default {
	init(modeler, context) {
		const {graph, onPatch, viewIndex} = context;
		const VIEW_INDEX = viewIndex ?? 0;

		const onViewNodeAdded = ({node} = {}) => {
			if (!node?.identifier) return;
			onPatch({
				patches: [
					{
						op: 'addNode',
						viewIndex: VIEW_INDEX,
						node: {
							identifier: node.identifier,
							elementRef: node.elementRef,
							x: node.x,
							y: node.y,
							w: node.w,
							h: node.h,
							type: node.type,
							name: node.name,
							label: node.label,
							fillColor: node.fillColor,
						},
					},
				],
			});
			applyViewpointDimming(modeler);
		};

		graph.on('node:added-to-view', onViewNodeAdded);

		return () => graph.off('node:added-to-view', onViewNodeAdded);
	},
};
